const Singleproduct = () => {

    const subscriptionInfo = document.getElementsByClassName('subscription-info__top')[0];

    if(subscriptionInfo) {
        subscriptionInfo.addEventListener('click', function() {

            if(this.classList.contains('active')) {
                this.classList.remove('active');
            } else {
                this.classList.add('active');
            }

        })
    }

}

export default Singleproduct;